module.exports = __webpack_public_path__ + "static/bg-header-everyday-life-edd2dcce599ca0a2b4cf05d6e598cd54.svg";